import { useToken } from "@dexteel/mesf-core";

// mesf-core tipa hasPermission con un number, pero lo que guarda del login son los
// ActionNames (los mismos strings que el backend le pasa a HasPermission). El cast
// queda acá para no repetirlo en cada componente.
export const useHasPermission = (actionName: string): boolean => {
	const { hasPermission } = useToken();
	return hasPermission(actionName as unknown as number);
};
